import { createFileRoute } from "@tanstack/react-router";

import { Reveal } from "@/components/site/motion";
import { getDict, href, type Lang } from "@/content/site";

export const Route = createFileRoute("/$lang/rfq/")({
  loader: ({ params }) => ({ lang: params.lang as Lang }),
  head: ({ loaderData }) => {
    const t = getDict(loaderData?.lang ?? "en");
    return { meta: [{ title: `${t.rfq.title} · insidermark` }, { name: "description", content: t.rfq.intro }] };
  },
  component: Page,
});

function Page() {
  const { lang } = Route.useLoaderData();
  const t = getDict(lang);
  return (
    <main>
      <header className="im-page-head">
        <div className="im-wrap">
          <Reveal>
            <h1 className="im-display">{t.rfq.title}</h1>
            <p className="im-body-text mt-5">{t.rfq.intro}</p>
          </Reveal>
        </div>
      </header>
      <section className="im-section im-section--tight">
        <div className="im-wrap">
          <div className="im-cards">
            {t.rfq.flows.map((f) => (
              <a className="im-card" href={href(lang, `/rfq/${f.flow}`)} key={f.flow}>
                <span className="im-mono">{f.time}</span>
                <h3>{f.title}</h3>
                <p>{f.body}</p>
                <span className="im-mono">{t.rfq.common.submit} →</span>
              </a>
            ))}
          </div>
          <p className="im-mono mt-8 max-w-[70ch]">{t.rfq.common.privacy}</p>
        </div>
      </section>
    </main>
  );
}
